import React from 'react'

export default () => (
  <div className="stats-pane">
    <div className="stat">
      <div className="stat-number">
        4B+
      </div>
      <div className="stat-text">
        Streamable video views
      </div>
    </div>
    <div className="stat">
      <div className="stat-number">
        1M+
      </div>
      <div className="stat-text">
        Streamable videos created
      </div>
    </div>
    <div className="stat">
      <div className="stat-number">
        7000+
      </div>
      <div className="stat-text">
        writers using Streamable
      </div>
    </div>
    <div className="stat">
      <div className="stat-number">
        50M+
      </div>
      <div className="stat-text">
        monthly viewers on the Streamable network
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/landing/Stats.js